<svg class="icon" [ngClass]="'icon-'+icon+' icon-'+color" [class.icon_colored]="color" [class.icon-hover]="hover" [class.icon_stroke]="stroked" [class.path]="path" [ngStyle]="styles">
  <use [attr.xlink:href]="'#'+icon"></use>
</svg>
